import { useIntersection } from '@mantine/hooks';
import { keepPreviousData } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useMemo, useState } from 'react';

import { useSearchArtists } from '@/features/search/api';
import { useIsLoading } from '@/shared/hooks/useIsLoading';

export const useClubSearchPage = () => {
  const [country, setCountry] = useState<string[]>([]);
  const navigate = useNavigate({ from: '/clubOwner/$id/search' });
  const { ref: elementRef, entry } = useIntersection();
  const countryParams = useMemo(
    () => (country?.length > 1 ? country.join(',') : country[0]),
    [country]
  );

  const artists = useSearchArtists(
    {
      countries: countryParams
    },
    {
      options: {
        placeholderData: keepPreviousData
      }
    }
  );

  useEffect(() => {
    if (entry?.isIntersecting) {
      artists.fetchNextPage();
    }
  }, [entry?.isIntersecting]);

  const posts = useMemo(
    () => artists.data?.pages.flatMap((page) => page.data.items),
    [artists.data?.pages]
  );

  const isLoading = useIsLoading([artists]);

  return {
    state: {
      isLoading,
      country,
      setCountry,
      artistsList: posts,
      elementRef
    },
    functions: {
      navigate
    }
  };
};
